// extracted by css-extract-rspack-plugin
module.exports =  {"logoAd":"WBwgJ","adLogoText":"e_GCz","leftAlign":"GiSdJ","leftMargin":"wzTUi"};